import { render } from "./Inconformidades.vue?vue&type=template&id=2deb1d7f&scoped=true"
import script from "./Inconformidades.vue?vue&type=script&lang=js"
export * from "./Inconformidades.vue?vue&type=script&lang=js"

import "./Inconformidades.vue?vue&type=style&index=0&id=2deb1d7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2deb1d7f"]])

export default __exports__